// helper function to check we we need to show the fees in the cart
// list of productIds that needs to show the fees in the cart

const showFeesInCart = (productId) => {
  const productIds = [
    'e22fe4f6-4323-409c-92dd-7c08c821261d',
    '0dad57b7-4eb3-471c-afd2-08dcc2a21c47',
    '13509931-13e2-46ee-905d-08dcc1506fac',
    'a4911fd3-f74c-46d4-9f62-4c01edead7fc',
    '374dcca8-6e4f-4a7c-afd1-08dcc2a21c47',
    'b9e7cf2f-5685-4abf-e556-08dbbf5f0502',
    '66cd0a37-37e9-4862-abb2-e7a40b05d99b',
    'a3c362b1-2ec4-4f5b-8048-0c941ededb14',
    'c45e1c36-e744-451c-afd3-08dcc2a21c47',
    '36c6f161-3616-47b8-5138-08dce85ffe3c', // Florida First Time Driver Drug and Alcohol Traffic Awareness + Florida Online Permit Exam
    '3275a493-fc68-497a-5137-08dce85ffe3c', // Florida First Time Driver Drug and Alcohol Traffic Awareness + Florida Online Permit Exam + Florida Permit Prep
    '98caee42-8d39-41b2-0e14-08dbe6b872bb', // design test product
    '81c5a7d6-d147-4a19-697e-08ddc4610f64', // DETS (old)
    '103ca87b-1886-43de-80de-08de10c8b3ba', // DETS (current as of 10/27/25)
    '23d1e52e-1d85-4742-57e1-08de290cbe51', // DETS Spanish
    'd3b75655-8ab1-4820-e3b4-08ddcaa816ee', // DETS+ Permit
    'ab206f8f-788f-4eba-c501-08de26a33947', // DETS + Permit Test Package Spanish
  ];

  return productIds.includes(productId);
};

export default showFeesInCart;
